import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {CustomerServiceState} from "@/interfaces/state/customerService";
import store from "@/store";
import {CustomerService} from "@/interfaces/entity/customerService";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {CustomerServiceParams} from "@/modules/customerservice/params";
import {createCustomerService, deleteCustomerService, listCustomerService, singleCustomerService, updateCustomerService} from "@/modules/customerservice/services";

@Module({dynamic: true, name: "customerService", store})
class CustomerServiceModule extends VuexModule implements CustomerServiceState {
    data: IdMapper<CustomerService> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: CustomerServiceParams = new CustomerServiceParams();

    @Mutation
    private MAP_CUSTOMER_SERVICE(payload: any) {
        const idMapper = {} as any;
        this.meta = payload.meta;
        this.ids = payload.datas.map((customerService: CustomerService, index: number) => {
            idMapper[customerService.id] = {...customerService, stt: index + 1}
            return customerService.id
        });
        this.data = idMapper;
    }

    @Mutation
    private UPDATE_PARAMS_CUSTOMER_SERVICE(payload: any) {
        this.params = payload;
    }

    @Mutation
    private DELETE_CUSTOMER_SERVICE(payload: CustomerService) {
        if (!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.ids = this.ids.filter((id: number) => id !== payload.id);
        delete this.data[payload.id];
    }

    @Action({ rawError: true })
    public async createCustomerService(payload: any) {
        await createCustomerService(payload);
    }

    @Action({ rawError: true })
    public async singleCustomerService(payload: any) {
        const { data } = await singleCustomerService(payload);
        return data.data;
    }

    @Action({ rawError: true })
    public async updateCustomerService(payload: any) {
        await updateCustomerService(payload.id, payload);
    }

    @Action({ rawError: true })
    public async deleteCustomerService(payload: any) {
        const {data} = await deleteCustomerService(payload);
        this.DELETE_CUSTOMER_SERVICE(data.data);
    }

    @Action({ rawError: true })
    public async listCustomerService(params: any) {
        const { data } = await listCustomerService(params);
        this.MAP_CUSTOMER_SERVICE(data);
    }

    @Action({ rawError: true })
    public updateParams(payload: any) {
        this.UPDATE_PARAMS_CUSTOMER_SERVICE(payload);
    }
}
export const CustomerServiceStore = getModule(CustomerServiceModule)
